import styled, { css } from 'styled-components';

export default styled.div`
  display: block;
  padding: 10px 0 30px 0;
  color: ${(props) => props.theme.primaryColor};

  ${({ $useTheWhiteColor }) => $useTheWhiteColor && css`
    color: white;
  `}
`;
